// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICatchUpAgePropertyDto
 */
export interface ICatchUpAgePropertyDto {
    /**
     * 
     * @type {number}
     * @memberof ICatchUpAgePropertyDto
     */
    catch_up_age?: number;
    /**
     * 
     * @type {string}
     * @memberof ICatchUpAgePropertyDto
     */
    catch_up_age_state?: ICatchUpAgePropertyDtoCatchUpAgeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum ICatchUpAgePropertyDtoCatchUpAgeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the ICatchUpAgePropertyDto interface.
 */
export function instanceOfICatchUpAgePropertyDto(value: object): value is ICatchUpAgePropertyDto {
    return true;
}

export function ICatchUpAgePropertyDtoFromJSON(json: any): ICatchUpAgePropertyDto {
    return ICatchUpAgePropertyDtoFromJSONTyped(json, false);
}

export function ICatchUpAgePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICatchUpAgePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'catch_up_age': json['catch_up_age'] == null ? undefined : json['catch_up_age'],
        'catch_up_age_state': json['catch_up_age_state'] == null ? undefined : json['catch_up_age_state'],
    };
}

export function ICatchUpAgePropertyDtoToJSON(json: any): ICatchUpAgePropertyDto {
    return ICatchUpAgePropertyDtoToJSONTyped(json, false);
}

export function ICatchUpAgePropertyDtoToJSONTyped(value?: ICatchUpAgePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'catch_up_age': value['catch_up_age'],
        'catch_up_age_state': value['catch_up_age_state'],
    };
}

